import playlistReducer from "../reducer/playlistReducer";
export const VERSION = '2.0.7'
let quality = '';
let mute = '';
let first = true;
let home = true;
let log = 0;
let offset = 0;
let interval = 120000;

// functions to generate random device Id
export function getDeviceName() {
  const deviceId = getId();
  return deviceId;
}

function getId() {
  const deviceId = get('device-id');
  if (deviceId) {
    return deviceId.toUpperCase();
  }
  let uid = getUID();
  uid = uid.toUpperCase();
  set('device-id', uid);
  return uid;
}

function get(key) {
  return localStorage[`bd-android-app__${key}`];
}

function set(key, val) {
  localStorage[`bd-android-app__${key}`] = val;
}

function getUID() {
  return "AND" + genRandStr(9);
}

function genRandStr(length = 41) {
  // Math.random returns number with length between 16 and 18 chars
  // if length below 16 do in one go
  if (length <= 16) {
    return Math.random().toString(36).substring(2, length + 2);
  }

  // else calculate how many iterations we need
  const iterations = Math.ceil(length / 16);
  let outputStr = '';

  for (let i = 0; i < iterations; i += 1) {
    outputStr += Math.random().toString(36).substring(2, 18);
  }

  // correct length if it's too high
  if (outputStr.length > length) {
    outputStr = outputStr.substring(0, length);
  }

  return outputStr;
}

// send canvas details to android app
export function sendCanvasDetails(deviceName, deviceId) {
  myWebView.getCanvasDetails(deviceName, deviceId, VERSION);
}

// send artworks json to android app
export function sendArtworks(artworks, playlistName="", quality="high", mute="false", fromMobile="false", artworkIndex=0, isFeatured="false", isSubscribed="false", interval=120000) {

  myWebView.getArtworks(JSON.stringify(artworks), playlistName, quality, mute, fromMobile, artworkIndex, isFeatured, isSubscribed, interval);
}

// send playlists json to android app
export function sendPlaylists(playlists) {
  myWebView.getPlaylists(JSON.stringify(playlists));
}

// send playlist and artwork indexes to android app
export function sendIndexes( playlistIndex, artworkId, offset=0, quality="high", mute="false") {
  myWebView.getIndexes(playlistIndex, artworkId, offset, quality, mute);
}

export function sendMuteAndQualityFlagStatus(quality, mute, interval) {
  myWebView.getMuteAndQualityFlagStatus(quality, mute, interval);
}

export function setQualityFlag(quality1) {
  quality = quality1;
}

export function getQualityFlag() {
  return quality;
}

export function setMuteFlag(mute1) {
  mute = mute1;
}

export function getMuteFlag() {
  return mute;
}

export function setArtInterval(interval1) {
  interval = interval1;
}

export function getArtInterval() {
  return interval;
}

// check if home screen opened for first time
export function setFirstTime(first1) {
  first = first1;
}

export function getFirstTime() {
  return first;
}

// check if home screen is the first screen
export function setIsHomeFirstScreen(home1) {
  home = home1;
}

export function getIsHomeFirstScreen() {
  return home;
}

// 
export function setFirst(log1) {
  log = log1;
}

export function getFirst() {
  return log;
}

// store movement of playlist from center to send playlist index to android app
export function storeOffset(offset1) {
  offset = offset1;
}

export function getOffset() {
  return offset;
}